// 'ServiceDelivery' -> 'Service Delivery' for display; the stored stage code itself stays unspaced.
export function stageLabel(stage: string): string {
  return stage.replace(/([a-z])([A-Z])/g, '$1 $2');
}

// Every lifecycle stage a type can have, in lifecycle order (a type uses its own subset, see its lifecycle-stages).
export const INTERVENTION_STAGES = [
  'New',
  'Eligibility',
  'Assessment',
  'Referral',
  'ServiceDelivery',
  'Reporting',
  'Approval',
  'Closed',
] as const;
